module.exports = __webpack_public_path__ + "static/img/005@2x.795fc76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/005@2x.png
// module id = ZAVE
// module chunks = 1